import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import Helmet from 'react-helmet';
import { usePage } from '@inertiajs/inertia-react';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink } from '@inertiajs/inertia-react';
import SiteLayout from '../../Shared/SiteLayout';
import SelectInput from '../../Shared/SelectInput';
import LoadingButton from '../../Shared/LoadingButton';
import classNames from 'classnames';
import TextInput from '../../Shared/TextInput';

function Index() {
     const { auth, app, errors, data } = usePage().props;
     const [sending, setSending] = useState(false);
     const [values, setValues] = useState({
          hologramme: '',
          prenom: '',
          nom: '',
          sex: '',
          nomecole: '',
          commune: '',
          ville: '',
          email: '',
          nophone: '',
          filteredSuggestions: [],
          showSuggestions: true,
     });

     function handleChange(e) {
          const key = e.target.name;
          const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
          setValues(values => ({
               ...values,
               [key]: value
          }));
     }

     function handleAutoCompleteChange(e) {
          const key = e.target.name;
          const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
          let comun = data.commune.filter(data => data.toLowerCase().indexOf(value.toLowerCase()) > -1);
          setValues(values => ({
               ...values,
               commune: value,
               filteredSuggestions: comun,
               showSuggestions: true,
          }));
     }

     function handleChoice(text) {
          setValues(values => ({
               ...values,
               commune: text,
               filteredSuggestions: [],
               showSuggestions: false,
          }));
     }

     function handleSubmit(e) {
          e.preventDefault();
          setSending(true);
          Inertia.post(route('notebook.post.user'), values).then(() => {
               setSending(false);
          });
     }

     return (
          <React.Fragment key="cahier-exo">
               <Helmet>
                    <title>{app.name}</title>
               </Helmet>
               <section className="w-full bg-white pt-5 pb-10">
                    <form onSubmit={handleSubmit}>
                         <div className="container mx-auto md:p-3">
                              <div className="max-w-7xl">
                                   <h1 className="font-bold text-center sm:text-3xl md:text-4xl uppercase bg-clip-text text-emerald-800">Cahier d'Exercices</h1>
                              </div>
                              <div className="w-full p-4 mt-2 bg-gray-100 rounded">
                                   <div className="w-full text-center text-sm text-gray-600 italic">
                                        Les champs ayant <span className="text-red-700">*</span> sont obligatoires.
                                   </div>
                                   <div className="w-full md:flex gap-3">
                                        <div className="sm:w-full md:w-1/6"></div>
                                        <div className="sm:w-full md:w-2/6">
                                             <TextInput
                                                   className="form-input rounded-md shadow-sm mt-4 block w-full"
                                                   label="Numéro de l'Hologramme"
                                                   name="hologramme"
                                                   type="text"
                                                   disable={false}
                                                   readonly={false}
                                                   must={true}
                                                   errors={errors.hologramme}
                                                   value={values.hologramme}
                                                   onChange={handleChange}
                                              />
                                             <TextInput
                                                   className="form-input rounded-md shadow-sm mt-4 block w-full"
                                                   label="Prénom"
                                                   name="prenom"
                                                   type="text"
                                                   disable={false}
                                                   readonly={false}
                                                   must={true}
                                                   errors={errors.prenom}
                                                   value={values.prenom}
                                                   onChange={handleChange}
                                              />
                                              <TextInput
                                                    className="form-input rounded-md shadow-sm mt-4 block w-full"
                                                    label="Nom"
                                                    name="nom"
                                                    type="text"
                                                    disable={false}
                                                    readonly={false}
                                                    must={true}
                                                    errors={errors.nom}
                                                    value={values.nom}
                                                    onChange={handleChange}
                                               />
                                               <SelectInput
                                                   className="block mt-4 appearance-none w-full text-gray-700 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                   label="Sexe"
                                                   name="sex"
                                                   errors={errors.sex}
                                                   value={values.sex}
                                                   onChange={handleChange}
                                               >
                                                   <option value="">Selectionne le Sexe</option>
                                                   {data.sex.map((s, i) => {
                                                        return <option key={`s${i}`} value={s}>{s}</option>
                                                   })}
                                               </SelectInput>
                                        </div>
                                        <div className="sm:w-full md:w-2/6">
                                               <TextInput
                                                     className="form-input rounded-md shadow-sm mt-4 block w-full"
                                                     label="Nom de l'École"
                                                     name="nomecole"
                                                     type="text"
                                                     disable={false}
                                                     readonly={false}
                                                     must={true}
                                                     errors={errors.nomecole}
                                                     value={values.nomecole}
                                                     onChange={handleChange}
                                                />
                                                <TextInput
                                                     className="form-input rounded-md shadow-sm mt-4 block w-full"
                                                     label="Commune"
                                                     name="commune"
                                                     type="text"
                                                     disable={false}
                                                     readonly={false}
                                                     must={true}
                                                     autocomplete={false}
                                                     errors={errors.commune}
                                                     value={values.commune}
                                                     onChange={handleAutoCompleteChange}
                                                />
                                                  {(values.showSuggestions && values.commune) && (<div className={`sticky rounded-md shadow-sm mt-1 block w-full z-50 bg-white`}>
                                                       <ul className="list-none list-inside">
                                                            {values.filteredSuggestions.map((com, i) => {
                                                                 return <li key={`cm${i}`} onClick={()=>handleChoice(com)} className="p-2 hover:bg-emerald-400 hover:text-gray-100">{com}</li>
                                                            })}
                                                       </ul>
                                                </div>)}
                                                <TextInput
                                                     className="form-input rounded-md shadow-sm mt-4 block w-full"
                                                     label="Email"
                                                     name="email"
                                                     type="text"
                                                     disable={false}
                                                     readonly={false}
                                                     errors={errors.email}
                                                     value={values.email}
                                                     onChange={handleChange}
                                                />

                                                <TextInput
                                                     className="form-input rounded-md shadow-sm mt-4 block w-full"
                                                     label="Téléphone"
                                                     name="nophone"
                                                     type="text"
                                                     disable={false}
                                                     readonly={false}
                                                     errors={errors.nophone}
                                                     value={values.nophone}
                                                     onChange={handleChange}
                                                />
                                                <div className="flex items-center justify-end mt-4">
                                                    <LoadingButton type="submit" loading={sending} className="inline-flex items-center px-4 py-2 bg-emerald-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-emerald-700 active:bg-emerald-900 focus:outline-none focus:border-emerald-900 focus:shadow-outline-emerald disabled:opacity-25 transition ease-in-out duration-150 ml-4">
                                                         Je m'identifie
                                                    </LoadingButton>
                                               </div>
                                        </div>
                                        <div className="sm:w-full md:w-1/6"></div>
                                   </div>
                              </div>
                         </div>
                    </form>
               </section>
          </React.Fragment>
     );
}

Index.layout = page => <SiteLayout children={page} header={'Cahier Exercice'} />;

export default Index;
